








import { Component } from 'vue-property-decorator'
import { EventUtils } from '@/utils'
import Vue from 'vue'

@Component
export default class WelcomeScreen extends Vue {
  ErrorMessage: string = ''

  async mounted() {
    const ErrorSubscription = {
      next: (errorMessage) => {
        this.ErrorMessage = errorMessage
        setTimeout(() => {
          this.ErrorMessage = ''
        }, 2000)
      },
      error: (error) => {
        console.log(error)
      },
      complete: () => {
        console.log('finished')
      },
    }
    EventUtils.subscribeErrorLabel(ErrorSubscription)
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ErrorLabel.vue